<div class="wms-spinner-container" *ngIf="fetchingData">
  <div class="wms-spinner-overlay"></div>
  <div class="wms-spinner large">
    <div class="loader">
      <i class="wms wms-logo"></i>
      <svg class="circular">
        <circle class="path" cx="50" cy="50" [attr.r]="25" fill="none" stroke-miterlimit="10"/>
      </svg>
    </div>
  </div>
</div>

<div *ngIf=" !fetchingData && hasNoIssues" class="ftux-screen horizontal-center">
  <div class="noIssuescol mb-25">
    <img class="noIssuesImg" [src]="('styles/images/ftux/api_issues.svg' | versionManager)" alt="" />
    <h5 *ngIf="!issuesService.isFirstChecked || !isApiCount" class="validation-error">{{locale.MSG_IMPACT_ANALYSIS_REPORT }}<a
      target="_blank"
      [href]="reImportApilink">{{locale.LABEL_CLICK_HERE}}</a>{{locale.LABEL_MORE_DETAILS}}</h5>
    <h5 *ngIf="issuesService.isFirstChecked && isApiCount" class="validation-error">{{locale.LABEL_NO_ISSUES_FOUND_APIS}}</h5>
  </div>
</div>
<div *ngIf="isError" class="ftux-screen horizontal-center">
  <div class="noIssuescol">
    <i class="wms wms-error-outline"></i>
    <h4 class="validation-error">{{locale.MSG_UNEXPECTED_ERROR}}</h4>
  </div>
</div>

<div class="col-xs-12 no-padding full-height" *ngIf="!fetchingData && !hasNoIssues && !isError">

  <div class="col-xs-8 issues" [ngClass]="{'has-select-info-text': noAPISelected || noIssueLocationSelected}">

    <div class="col-xs-12 no-padding selectors">
      <!--- API dropdown --->
      <div class="selector api-selector">
        <span class="col-xs-12 no-padding header">{{locale.LABEL_API}}</span>
        <div class="col-xs-12 no-padding">
          <wms-combo-box id="apiDD" [options]="apisDisplayObj" optionKey="serviceId" subOptionkey="issueCount" [model]="selectedAPI.displayName"
                         (onSelect)="updateSelectedAPI($event)" (onClear)="onAPIClear()"
                         customClass="api-issues api"></wms-combo-box>
        </div>
      </div>

      <!--- Issue Location dropdown --->
      <div class="selector issue-location-selector">
        <span class="col-xs-12 no-padding header">{{locale.LABEL_ISSUE_LOCATION}}</span>
        <div class="col-xs-12 no-padding">
          <wms-combo-box id="issueLocationDD" [options]="issueLocationsDisplayObj" optionKey="pageName" subOptionkey="totalIssues" [model]="selectedIssueLocation.displayName"
                         (onSelect)="updateSelectedIssueLocation($event)" (onClear)="onIssueLocationClear()" [message]="locale.LABEL_PLEASE_SELECT_API"
                         customClass="api-issues issue-location"></wms-combo-box>
        </div>
      </div>
    </div>
    <div class="col-xs-12 no-padding filtered-issues" *ngIf="!noAPISelected && !noIssueLocationSelected">
      <div class="header-row">
        <span>{{selectedIssueLocation.pageName === 'Application' && locale.LABEL_PROJECTS_LIST_APPLICATION ||
        (selectedIssueLocation.pageType === 'PAGE' && locale.LABEL_PROPERTY_PAGE || locale.LABEL_PARTIAL)}} {{locale.LABEL_ISSUES}} ({{selectedIssueLocation.totalIssues}})</span>
      </div>
      <div class="issues-list">
        <div *ngFor="let issueInfo of issues">
          <div *ngFor="let issue of issueInfo.issues" class="issue-list-item" [ngClass]="{'active':selectedIssue===issue, 'error' : issue['errorLevel'] === 'ERROR', 'warn' : issue['errorLevel'] !== 'ERROR'}" (click)="selectedIssue = issue">
            <span class="issue-type">{{issue.type | titlecase}}: </span>
            <span>{{issue.description}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- resolution steps -->
  <div class="col-xs-4 resolution-steps" *ngIf="!noAPISelected && !noIssueLocationSelected">
    <div *ngIf="!selectedIssue" class="issue-select">
      <p>{{locale.LABEL_SELECT_ISSUE_TO_SEE_RESOLUTION_STEPS}}</p>
    </div>
    <div class="resolution-steps-ctnr">
      <ng-container *ngIf="selectedIssue">
        <h3 class="text-border resolution-steps-heading">{{locale.LABEL_RESOLUTION_STEPS}}</h3>
        <div class="resolutionscroll">
          <ul *ngFor="let item of selectedIssue.resolutionSteps |keyvalue; index as i" class="resolutionStep">
            <li class="resolutionlist">
              <span *ngIf="!startsWithNote(item.value)">
                {{ i + 1 }}. <!-- Display the index number -->
              </span>
              <ng-container *ngIf="isGoToPage(item.value)">
                <span [innerHTML]="prefix">
                </span>
                <a class="text-color" (click)="goToPage(selectedIssue.pageName)">{{ selectedIssue.pageName }}</a>
                <span [innerHTML]="suffix">
                </span>
              </ng-container>
              <ng-container *ngIf="!isGoToPage(item.value)" >
                <span [innerHTML]="item.value"></span>
              </ng-container>
          </li>
        </ul>
      </div>
      </ng-container>
    </div>
  </div>
  <div class="col-xs-12 select-info-text"  *ngIf="noAPISelected || noIssueLocationSelected">
    <div *ngIf="!selectedIssue" class="issue-select">
      <p *ngIf="noAPISelected">{{locale.LABEL_SELECT_API_TO_SEE_ISSUES}}</p>
      <p *ngIf="!noAPISelected && noIssueLocationSelected">{{locale.LABEL_SELECT_ISSUE_LOCATION_TO_SEE_ISSUES}}</p>
    </div>
  </div>
</div>
